import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    primary: {
      main: '#345e5cff',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
    h1: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 600,
    },
    h2: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
    },
    body2: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
    },
    button: {
      fontFamily: '"Gill Sans", "Gill Sans MT", "Calibri", "Trebuchet MS", sans-serif',
      fontWeight: 500,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
            <App />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);